import { render } from "./followersTab.vue?vue&type=template&id=54936834"
import script from "./followersTab.vue?vue&type=script&lang=js"
export * from "./followersTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__